/**
 * @generated SignedSource<<49f75a65462c3951b9e8d2153cf7c986>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuImagesGallery_ProductSkuImageConnection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuImageGalleryPaginator_ProductSkuImageConnection">;
  readonly " $fragmentType": "ProductSkuImagesGallery_ProductSkuImageConnection";
};
export type ProductSkuImagesGallery_ProductSkuImageConnection$key = {
  readonly " $data"?: ProductSkuImagesGallery_ProductSkuImageConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuImagesGallery_ProductSkuImageConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuImagesGallery_ProductSkuImageConnection",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductSkuImageGalleryPaginator_ProductSkuImageConnection"
    }
  ],
  "type": "ProductSkuImageConnection",
  "abstractKey": null
};

(node as any).hash = "4e4aafdcc9e7ae24792677a9f4953cc2";

export default node;
